"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassMapper = void 0;
class ClassMapper {
    toClass(classResource) {
        return {
            id: classResource.id,
            createdAt: new Date(classResource.attributes.createdAt),
            updatedAt: new Date(classResource.attributes.updatedAt),
            title: classResource.attributes.title,
            description: classResource.attributes.description,
        };
    }
    toClassResource($class) {
        return {
            id: $class.id,
            type: 'Class',
            attributes: {
                createdAt: $class.createdAt.toISOString(),
                updatedAt: $class.updatedAt.toISOString(),
                title: $class.title,
                description: $class.description,
            },
        };
    }
    toClassCreation(classCreationResource) {
        return {
            title: classCreationResource.attributes.title,
            description: classCreationResource.attributes.description,
        };
    }
    toClassCreationResource(classCreation) {
        return {
            type: 'Class',
            attributes: {
                title: classCreation.title,
                description: classCreation.description,
            },
        };
    }
    toClassUpdate(classUpdateResource) {
        return {
            id: classUpdateResource.id,
            title: classUpdateResource.attributes.title,
            description: classUpdateResource.attributes.description,
        };
    }
    toClassUpdateResource(classUpdate) {
        return {
            id: classUpdate.id,
            type: 'Class',
            attributes: {
                title: classUpdate.title,
                description: classUpdate.description,
            },
        };
    }
}
exports.ClassMapper = ClassMapper;
//# sourceMappingURL=#class-mapper.js.map